//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.NullableBooleanAdapter
import com.apollographql.apollo.api.NullableStringAdapter
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.present
import com.wintermar.inspection.graphql.type.InspectionMediaDtoInput
import kotlin.IllegalStateException

public object InspectionMediaDtoInput_InputAdapter : Adapter<InspectionMediaDtoInput> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionMediaDtoInput = throw IllegalStateException("Input type used in output position")

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: InspectionMediaDtoInput,
  ) {
    writer.name("id")
    AnyAdapter.toJson(writer, customScalarAdapters, value.id)
    writer.name("fileName")
    StringAdapter.toJson(writer, customScalarAdapters, value.fileName)
    writer.name("originalFileName")
    StringAdapter.toJson(writer, customScalarAdapters, value.originalFileName)
    writer.name("size")
    IntAdapter.toJson(writer, customScalarAdapters, value.size)
    if (value.fileUploaded is Optional.Present) {
      writer.name("fileUploaded")
      NullableBooleanAdapter.present().toJson(writer, customScalarAdapters, value.fileUploaded)
    }
    if (value.fileUrl is Optional.Present) {
      writer.name("fileUrl")
      NullableStringAdapter.present().toJson(writer, customScalarAdapters, value.fileUrl)
    }
    if (value.thumbnailUrl is Optional.Present) {
      writer.name("thumbnailUrl")
      NullableStringAdapter.present().toJson(writer, customScalarAdapters, value.thumbnailUrl)
    }
  }
}
